<omg-template-search-filters [formGroup]="searchForm"></omg-template-search-filters>

<omg-templates-table [templates]="templates$ | async"
                     [loading]="loading$ | async"
                     (tagClick)="filterComponent.addTagFilter($event)">
</omg-templates-table>

<router-outlet></router-outlet>
